import { Navbar } from '@codeparva/ui-components-library';
import React, { useEffect, useRef } from 'react';
import { NavBarTypes } from '..';
import { weakKey } from '../../../../../utilities/weakKey';
import { NavBarButtonGroup } from '../NavBarButtonGroup';
import NavBarIcons from '../NavBarIcons';
import { NavBarLogo } from '../NavBarLogo';
import { NavBarMenus } from '../NavBarMenus';
import NavBarSocialMediaIcons from '../NavBarSocialMediaIcons';
import { useVariant } from '../hooks/NavBarContext';
import { SignInAvatarComponent } from './SignInAvatarComponent';

export const NavBarLogoIconAndBurgerHelper = ({
  facility,
  iconsConfig,
  phoneNumber,
  phoneNumberRedirect,
  locationType,
  handlenavbarBurgerState,
  handleNavBarStateForLogo,
  openNavBar,
}: NavBarTypes.TNavBarIconAndBurgerHelper) => {
  return (
    <Navbar.Brand className="navBarBrand" key={weakKey(facility)}>
      <NavBarLogo
        facility={facility}
        handleNavBarStateForLogo={handleNavBarStateForLogo}
      />
      <NavBarIcons
        AddressIcon={iconsConfig.facilityAddressIcon}
        facilityAddress={facility.facilityAddress}
        googleMapsUrl={facility.googleMapsUrl}
        PhoneNumberIcon={iconsConfig.phoneNumberIcon}
        phoneNumber={phoneNumber}
        phoneNumberRedirect={phoneNumberRedirect}
        locationType={locationType}
        iconsConfig={iconsConfig}
      />
      <Navbar.Burger
        onClick={handlenavbarBurgerState}
        className={openNavBar ? 'navbar-burger is-active' : 'navbar-burger'}
      ></Navbar.Burger>
    </Navbar.Brand>
  );
};

export const NavBarMenuHelper = ({
  openNavBar,
  navLinks,
  locationType,
  socialMediaIconsAndState,
  iconsConfig,
  renderPhoneNumberIcon,
  buttonsConfig,
  handleNavBarFunctions,
  LinkWrapper,
  globalContext,
  logOutHandler,
}: NavBarTypes.TNavBarMenuHelper) => {
  const currentVariant = useVariant();
  currentVariant.navLinkRef = useRef(null);
  useEffect(() => {
    if (currentVariant.navLinkRef) {
      currentVariant.activeLinkData = currentVariant.navLinkRef;
    }
  });
  return (
    <div
      ref={currentVariant.navLinkRef}
      className={`navbar-menu
        ${openNavBar ? 'is-active navbarMenuActive' : 'navbarMenuVariant'}`}
    >
      <Navbar.Container align="right">
        <NavBarMenus
          navLinks={navLinks}
          openNavBar={openNavBar}
          locationType={locationType}
          LinkWrapper={LinkWrapper}
          globalContext={globalContext}
        />
      </Navbar.Container>
      <NavBarSocialMediaIcons {...socialMediaIconsAndState} />
      {iconsConfig.phoneNumberIcon && renderPhoneNumberIcon()}
      {buttonsConfig && buttonsConfig.length > 0 && (
        <Navbar.Container
          align="right"
          className={
            currentVariant.variantType === 'header-3' ? 'is-hidden-desktop' : ''
          }
        >
          <Navbar.Item href="#" renderAs="div" className="navBarButtons">
            <NavBarButtonGroup
              buttonsConfig={buttonsConfig}
              handleNavBarStateButton={
                handleNavBarFunctions.handleNavBarStateButton
              }
            />
          </Navbar.Item>
        </Navbar.Container>
      )}
      <SignInAvatarComponent
        buttonsConfig={buttonsConfig}
        globalContext={globalContext}
        handleNavBarFunctions={handleNavBarFunctions}
        logOutHandler={logOutHandler}
      />
    </div>
  );
};
